module.exports = __webpack_public_path__ + "img/ic-next-arrow-gray.e4f1755c.svg";